package pwgs.ui.scenes.custompropertieseditorscene

import visage.core.AComponent
import visage.core.Components
import visage.core.AScene
import visage.ds.components.*
import visage.ds.utils.EHAlign

class MCustomPropertiesEditorScene(props: CustomPropertiesEditorSceneProps) : AScene<CustomPropertiesEditorSceneProps, CustomPropertiesEditorSceneModel, CustomPropertiesEditorSceneState, CustomPropertiesEditorControllerFe>(props) {

    override fun createController() : CustomPropertiesEditorControllerFe {
        return CustomPropertiesEditorControllerFe(props, this)
    }

    override fun initState() : CustomPropertiesEditorSceneState {
        return CustomPropertiesEditorSceneState()
    }

    override fun Components.render(children: List<AComponent<*>>) {
        val m = this@MCustomPropertiesEditorScene.model
        Card {
            isLoading = m.isLoading

            header("Properties") {
                ResponsiveButtonWithIcon("add", "Create new property", EButtonColor.Success, this@MCustomPropertiesEditorScene.controller::onCreateNewPropertyButtonClicked)
            }

            body {
                Table {
                    columns {
                        fixedColumn("Name")
                        fixedColumn("Type")
                        fixedColumn("Default value")
                        fixedColumn("Editable")
                        fixedColumn("Indexed")
                        fixedColumn("", hAlign = EHAlign.Right)
                    }

                    body {
                        m.items.forEach { p ->
                            row {
                                cell(p.propertyName)
                                cell(p.type.name)
                                cell(p.value)
                                cell(if (p.isEditable) "Yes" else "No")
                                cell(if (p.isIndexed) "Yes" else "No")
                                cell {
                                    IconButton("edit") {
                                        size = EButtonSize.Small
                                        variant = EButtonVariant.Link
                                        color = EButtonColor.Warning
                                        onClick = {
                                            this@MCustomPropertiesEditorScene.controller.onEditPropertyClicked(
                                                p.propertyName,
                                                p.type.name,
                                                p.value,
                                                p.isEditable.toString().lowercase(),
                                                p.isIndexed.toString().lowercase()
                                            )
                                        }
                                    }
                                    IconButton("delete") {
                                        size = EButtonSize.Small
                                        variant = EButtonVariant.Link
                                        color = EButtonColor.Danger
                                        onClick = { this@MCustomPropertiesEditorScene.controller.onDeletePropertyClicked(p.propertyName)}
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        if (m.editorModel != null) {
            val dm = m.editorModel!!
            Modal(if (dm.isUpdate) "Update property" else "Create new property") {
                isLoading = dm.isLoading
                error = dm.error
                infoText = if (dm.isUpdate) {
                    "Fill the form below to change the custom property"
                } else {
                    "Fill the form below to create a new custom property"
                }

                TextField("Name", dm.nameFieldModel) {
                    disabled = dm.isUpdate
                }
                Select("Type", dm.typeFieldModel) {
                    disabled = dm.isUpdate
                    onChange = {
                        this@MCustomPropertiesEditorScene.refresh()
                    }
                }
                if (dm.typeFieldModel.value == ECustomFieldType.Bool.name) {
                    Select("Default value", dm.boolValueFieldModel)
                } else {
                    TextField("Default value", dm.valueFieldModel)
                }

                Select("Client Editable", dm.editableFieldModel) {
                    infoText = "Indicates if this field can be changed from the client or not"
                }

                Select("Indexed", dm.indexedFieldModel) {
                    infoText = "Indicates if this field is indexed. Only indexed fields can be used in querys"
                }

                footer {
                    Button("Cancel", EButtonColor.Secondary, EButtonVariant.Link, this@MCustomPropertiesEditorScene.controller::onCancelPropertyEditorClicked)
                    Button("Submit", EButtonColor.Primary, EButtonVariant.Filled, this@MCustomPropertiesEditorScene.controller::onSubmitPropertyEditorClicked)
                }
            }
        }
    }
}

class CustomPropertiesEditorSceneState {

}

fun Components.CustomPropertiesEditorScene(props: CustomPropertiesEditorSceneProps) = this.registerComponent(MCustomPropertiesEditorScene(props), {})
